import { createReduxConstants } from '@bibliocommons/utils-redux';

export default createReduxConstants('VIDEOS', {
  ADD_VIDEO_REQUEST: null,
  ADD_VIDEO_SUCCESS: null,
  ADD_VIDEO_FAILURE: null,
  UPDATE_VIDEO_REQUEST: null,
  UPDATE_VIDEO_SUCCESS: null,
  UPDATE_VIDEO_FAILURE: null,
  REMOVE_VIDEO_REQUEST: null,
  REMOVE_VIDEO_SUCCESS: null,
  REMOVE_VIDEO_FAILURE: null
});
